function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import './Breadcrumb.less';
var breadcrumbsDeskStyle = {
  borderBottom: 'none'
};
var breadcrumbsPalmStyle = {
  height: '20px'
};
var Breadcrumbs = /*#__PURE__*/function (_React$Component) {
  function Breadcrumbs(props) {
    var _this;
    _classCallCheck(this, Breadcrumbs);
    _this = _callSuper(this, Breadcrumbs, [props]);
    _defineProperty(_this, "realtorSearchLink", '/anbieter/immobilienmakler');
    _defineProperty(_this, "baseUrl", '/anbieter/immobilienmakler/de/');
    return _this;
  }
  _inherits(Breadcrumbs, _React$Component);
  return _createClass(Breadcrumbs, [{
    key: "parseGeoPath",
    value: function parseGeoPath(geoPathUri) {
      var geoPathRealNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!geoPathUri) {
        return [];
      }
      if (/\d+/.test(geoPathUri)) {
        var _geoPathRealNames = _slicedToArray(geoPathRealNames, 3),
          postCode = _geoPathRealNames[1],
          _city = _geoPathRealNames[2];
        return [postCode + ' ' + _city];
      }
      var _geoPathRealNames2 = _slicedToArray(geoPathRealNames, 5),
        region = _geoPathRealNames2[1],
        city = _geoPathRealNames2[2],
        district = _geoPathRealNames2[3],
        quarter = _geoPathRealNames2[4];
      return [region, city, district, quarter];
    }
  }, {
    key: "getLink",
    value: function getLink(locations, index) {
      return "".concat(this.baseUrl).concat(_toConsumableArray(locations).splice(0, index + 1).join('/'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        geoPathUri = _this$props.geoPathUri,
        geoPathRealNames = _this$props.geoPathRealNames;
      var locationRealNames = this.parseGeoPath(geoPathUri, geoPathRealNames);
      var locations = geoPathUri ? geoPathUri.split('/').splice(2) : [];
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
        className: "breadcrumb breadcrumb__regions palm-hide",
        style: breadcrumbsDeskStyle,
        "data-testid": "breadcrumb"
      }, /*#__PURE__*/React.createElement("li", {
        className: "breadcrumb__item"
      }, /*#__PURE__*/React.createElement("a", {
        href: this.realtorSearchLink
      }, "Immobilienmakler")), locationRealNames.map(function (locationName, index) {
        return locationName && /*#__PURE__*/React.createElement("li", {
          key: "".concat(locationName, "_").concat(index),
          className: "breadcrumb__item",
          "data-testid": locations[index]
        }, index < locationRealNames.length - 1 ? /*#__PURE__*/React.createElement("a", {
          href: _this2.getLink(locations, index)
        }, locationName) : locationName);
      })), /*#__PURE__*/React.createElement("ul", {
        className: "desk-hide lap-hide",
        style: breadcrumbsPalmStyle
      }, /*#__PURE__*/React.createElement("li", {
        className: "link-text float-left"
      }, /*#__PURE__*/React.createElement("a", {
        href: this.realtorSearchLink,
        className: "icon-arrow-back"
      }, "Zur Maklersuche"))));
    }
  }]);
}(React.Component);
export default Breadcrumbs;